import { type FC } from 'react';

import { useCreateReserveWithGoogleConversion } from '@service-initiation/tech-care-data-access-reserve-with-google';
import {
  DeliveryMethod,
  useDeliveryMethodValue,
} from '@service-initiation/tech-care-data-access-store';

import {
  MailInConfirmationPage,
  RemoteTechConfirmationPage,
  VisitStoreConfirmationPage,
} from './components';

const CONFIRMATION_PAGES: Record<DeliveryMethod, JSX.Element> = {
  [DeliveryMethod.ComeToMe]: <RemoteTechConfirmationPage />,
  [DeliveryMethod.MailIn]: <MailInConfirmationPage />,
  [DeliveryMethod.VisitStore]: <VisitStoreConfirmationPage />,
};

export const ConfirmationPage: FC = () => {
  const deliveryMethod = useDeliveryMethodValue();
  useCreateReserveWithGoogleConversion();

  return CONFIRMATION_PAGES[deliveryMethod];
};
